﻿import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver, { resolveLinkCollection } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import VeilederLutDto from '../Models/VeilederLutDto';
import { VeilederLutAppState } from '../Store';
import { ResultatValg } from '../Store/Resultat/Types';
import { BoksResultatB } from '../../VeilederLut/Ids';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultatOwnProps {
    //valg: ValgTypes.ValgState,
}

type ResultatDisplayProps = ResultatOwnProps & MapStateToProps;

function ResultatBComponent(props: ResultatDisplayProps): JSX.Element {
    const { epiContext } = props;
    useEffect(() => {
        updateLiveMessage();
    }, []);

    return (
        <div id={BoksResultatB} className="c-veileder__panel c-veileder__panel--lilac">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <h3 className="c-veileder__tittel">
                        {contentResolver(epiContext, 'tittelVenstreResultatKanskje')}
                    </h3>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <h4 className="c-veileder--overskrift c-veileder--overskrift-kjempestor">
                        {contentResolver(epiContext, 'tittelHoyreResultatKanskje')}
                    </h4>
                    <div className="c-veileder--tekstomraade">
                        {contentResolver(epiContext, 'infoResultatKanskje')}
                    </div>
                    {resolveLinkCollection(
                        epiContext,
                        'lenkeResultatKanskje',
                        'c-veileder__linkwrapper',
                        'c-knapp c-knapp--cta c-knapp--primary',
                    )}
                </div>
            </div>
        </div>
        )
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederLutDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederLutAppState, ownProps: ResultatOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    }
)(ResultatBComponent);
